(function (window, document) {
  'use strict';

  var app = window.MNBListing;
  if (!app || typeof app.register !== 'function') return;

  var MAX_IMAGE_BYTES = 10 * 1024 * 1024;
  var PHOTO_LIMIT_MESSAGE = 'You can upload a maximum of ' + app.MAX_PHOTOS + ' photos. Remove a photo to add another.';
  var MAX_IMAGE_EDGE = 1500;
  var IMAGE_QUALITY = 0.8;
  var OUTPUT_MIME = 'image/webp';
  var ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'];
  var HEIC_DECODER_URL = 'https://cdn.jsdelivr.net/npm/heic-to@1.6.5/dist/iife/heic-to.js';
  var heicDecoderLoading = null;
  var URI_SAFE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$';
  var reverseUriSafe = null;

  var root = null;
  var store = null;
  var config = {};
  var integrations = { capture: function () {} };
  var boundRoot = null;
  var dragState = null;

  var PROPERTY_MAP = {
    address_house_number: 'ah',
    address_street_name: 'as',
    address_city: 'aci',
    address_state: 'ast',
    address_postcode: 'ap',
    address_country: 'ac',
    address_countryCode: 'acc',
    condition: 'c',
    BikeColour: 'bc',
    ChangedPartsDescription: 'cpd',
    UpgradesReplacements: 'ur',
    BikeShortDescription: 'bsd',
    ListingPrice: 'lp',
    Height: 'h',
    BikeType: 'bty',
    BikeYear: 'by',
    Model: 'm',
    Brand: 'b',
    SerialNumber: 'sn',
    PreviousOwners: 'po',
    LastService: 'ls',
    BikeSizing: 'bs',
    BikeFrameSize2: 'bfs',
    DamageDescription: 'dd',
    DamagedParts: 'dp',
    user_ReferralSource: 'urs',
    user_PhoneNumber: 'upn',
    user_Email: 'ue',
    user_NameLast: 'unl',
    user_NameFirst: 'unf',
    user_id: 'uid',
    user_ReferralSourceOther: 'urso',
    EnterCode: 'ec',
    ProofOf: 'pof',
    EbikeWeight: 'ew',
    EbikeMaxCharge: 'emc',
    EbikePowerOutput: 'epo',
    EbikeMileage: 'em',
    EbikeElectricalCondition: 'eec',
    EbikeChargerIncluded: 'eci',
    EbikeChargerOriginal: 'eco',
    EbikeChargerAmperage: 'eca',
    EbikeBatteryHealth: 'ebh',
    EbikeBatteryHealthPercent: 'ebhp',
    bike_slug_brand: 'bksb',
    bike_slug_model: 'bksm',
    bike_slug_year: 'bksy',
    bike_data_SuggestedPrice: 'bsp',
    bike_data_Name: 'bn',
    bike_data_Charger: 'bch',
    bike_data_Remote: 'bre',
    bike_data_Grips: 'bg',
    bike_data_Spokes: 'bdsp',
    bike_data_RimWidth: 'bdrw',
    bike_data_RimDriver: 'bdrd',
    bike_data_BrakePistons: 'bdbp',
    bike_data_TireSize: 'bdts',
    bike_data_TireCompound: 'bdtc',
    bike_data_TireTubeless: 'bdtt',
    bike_data_ForkAxle: 'bdfa',
    bike_data_ForkOffset: 'bdfo',
    bike_data_ForkSteerer: 'bdfs',
    bike_data_HandlebarWidth: 'bdhbw',
    bike_data_HandlebarRise: 'bdhbr',
    bike_data_HandlebarSweep: 'bdhbs',
    bike_data_ChainGuide: 'bdcg',
    bike_data_Pedals: 'bp',
    bike_data_RearHub: 'brh',
    bike_data_FrontHub: 'bfh',
    bike_data_BottomBracket: 'bbb',
    bike_data_RearShock: 'brs',
    bike_data_SeatpostType: 'bst',
    bike_data_TravelRear: 'btr',
    bike_data_TravelFront: 'btf',
    bike_data_ForkMaterial: 'bfm',
    bike_data_WheelMaterial: 'bwm',
    bike_data_WheelSize: 'bws',
    bike_data_Gender: 'bge',
    bike_data_Weight: 'bw',
    bike_data_Fork: 'bf',
    bike_data_Seatpost: 'bse',
    bike_data_Saddle: 'bsa',
    bike_data_Handlebar: 'bhb',
    bike_data_Stem: 'bsm',
    bike_data_Headset: 'bhs',
    bike_data_Tires: 'bti',
    bike_data_Rims: 'bri',
    bike_data_Cassette: 'bca',
    bike_data_Shifters: 'bsh',
    bike_data_Chain: 'bch2',
    bike_data_Crank: 'bcr',
    bike_data_Brakes: 'bbr',
    bike_data_BrakeType: 'bbt',
    bike_data_FrontDerailleur: 'bfd',
    bike_data_RearDerailleur: 'brd',
    bike_data_FrameComponent: 'bfc',
    bike_data_SuspensionType: 'bsu',
    bike_data_Subcategory: 'bsc',
    bike_data_Battery: 'bba',
    bike_data_Motor: 'bmo',
    bike_data_Shifting: 'bsf',
    bike_data_Year: 'byr',
    bike_data_Category: 'bcat',
    bike_data_Rrp: 'brrp',
    bike_data_RrpGBP: 'brgb',
    bike_data_Drivetrain: 'bdt',
    bike_data_Groupset: 'bgs',
    bike_data_FrameMaterial: 'bfma',
    Subcategory: 'sub',
    fork_type: 'ft',
    fork_wheel_size: 'fws',
    fork_travel: 'ftr',
    shock_type: 'sht',
    shock_mounting: 'shm',
    shock_length: 'shl',
    shock_stroke: 'shs',
    groupset_type: 'gt',
    groupset_front_gears: 'gfg',
    groupset_rear_gears: 'grg',
    shifter_type: 'st',
    shifter_front_gears: 'sfg',
    shifter_rear_gears: 'srg',
    crank_material: 'cm',
    chain_gears: 'cg',
    cassette_gears: 'cag',
    bottom_bracket_mounting: 'bbm',
    chainring_mounting: 'crm',
    derailleur_type: 'dt',
    derailleur_rear_gears: 'drg',
    derailleur_front_mounting: 'dfm',
    brake_type: 'bt',
    brake_type2: 'bt2',
    brake_mounting: 'brm',
    brake_lever_type: 'blt',
    headset_design: 'hsd',
    handlebar_design: 'hbd',
    handlebar_material: 'hbm',
    stem_length: 'stl',
    stem_clamp_dimension: 'scd',
    seatpost_type: 'spt',
    seatpost_diameter: 'spd',
    tyre_wheel_size: 'tws',
    tyre_width: 'tw',
    wheel_type: 'wt',
    wheel_type2: 'wt2',
    wheel_size: 'ws',
    wheel_diameter: 'wd',
    pedal_type: 'pt',
    year: 'yr',
    sponsoredListing: 'sl',
    contact_Enquiry: 'ce',
    product_id: 'pid',
    product_slug: 'psl',
    tracking_clid: 'tgc',
    tracking_clid_type: 'tgct',
    tracking_client_id: 'tci',
    tracking_service: 'ts',
    tracking_ttp: 'ttp',
    tracking_fbp: 'fbp',
    tracking_distinct_id: 'tdi',
    media_drive: 'md',
    media_additional: 'ma',
    media_side: 'ms',
    media_drive_close: 'mdc',
    internal_media_drive: 'imd',
    internal_media_drive_preview: 'imdp',
    internal_media_additional: 'ima',
    internal_media_additional_preview: 'imap',
    internal_media_side: 'ims',
    internal_media_side_preview: 'imsp',
    internal_media_drive_close: 'imdc',
    internal_media_drive_close_preview: 'imdcp',
    internal_enquiry_type: 'iet',
    internal_listWithoutTemplate: 'ilwt',
    internal_phone_number_verified: 'ipnv',
    internal_user_id_verified: 'iuiv',
    internal_processing_files: 'ipf',
    internal_electric_bike: 'ieb',
    internal_upgraded_components: 'iuc'
  };

  var REVERSE_PROPERTY_MAP = Object.keys(PROPERTY_MAP).reduce(function (result, key) {
    result[PROPERTY_MAP[key]] = key;
    return result;
  }, {});

  var SENSITIVE_FIELDS = {
    internal_media_drive: true,
    internal_media_drive_preview: true,
    internal_media_additional: true,
    internal_media_additional_preview: true,
    internal_media_side: true,
    internal_media_side_preview: true,
    internal_media_drive_close: true,
    internal_media_drive_close_preview: true,
    user_Email: true,
    user_PhoneNumber: true,
    user_NameFirst: true,
    user_NameLast: true,
    address_house_number: true,
    address_street_name: true,
    address_city: true,
    address_postcode: true,
    SerialNumber: true
  };

  function hasOwn(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  }

  function cloneArray(value) {
    return Array.isArray(value) ? value.slice() : [];
  }

  function reverseDictionary() {
    if (reverseUriSafe) return reverseUriSafe;
    reverseUriSafe = {};
    for (var index = 0; index < URI_SAFE.length; index += 1) reverseUriSafe[URI_SAFE.charAt(index)] = index;
    return reverseUriSafe;
  }

  function compressWithBits(uncompressed, bitsPerChar, getCharFromInt) {
    var dictionary = {};
    var dictionaryToCreate = {};
    var w = '';
    var wc = '';
    var c = '';
    var enlargeIn = 2;
    var dictSize = 3;
    var numBits = 2;
    var data = [];
    var dataVal = 0;
    var dataPosition = 0;
    var i;
    var value;
    var ii;

    function writeBit(bit) {
      dataVal = (dataVal << 1) | bit;
      if (dataPosition === bitsPerChar - 1) {
        dataPosition = 0;
        data.push(getCharFromInt(dataVal));
        dataVal = 0;
      } else {
        dataPosition += 1;
      }
    }

    function writeValue(valueToWrite, bitCount) {
      for (i = 0; i < bitCount; i += 1) {
        writeBit(valueToWrite & 1);
        valueToWrite = valueToWrite >> 1;
      }
    }

    if (uncompressed == null) return '';
    for (ii = 0; ii < uncompressed.length; ii += 1) {
      c = uncompressed.charAt(ii);
      if (!hasOwn(dictionary, c)) {
        dictionary[c] = dictSize;
        dictSize += 1;
        dictionaryToCreate[c] = true;
      }
      wc = w + c;
      if (hasOwn(dictionary, wc)) {
        w = wc;
      } else {
        if (hasOwn(dictionaryToCreate, w)) {
          if (w.charCodeAt(0) < 256) {
            writeValue(0, numBits);
            writeValue(w.charCodeAt(0), 8);
          } else {
            writeValue(1, numBits);
            writeValue(w.charCodeAt(0), 16);
          }
          enlargeIn -= 1;
          if (enlargeIn === 0) {
            enlargeIn = Math.pow(2, numBits);
            numBits += 1;
          }
          delete dictionaryToCreate[w];
        } else {
          value = dictionary[w];
          writeValue(value, numBits);
        }
        enlargeIn -= 1;
        if (enlargeIn === 0) {
          enlargeIn = Math.pow(2, numBits);
          numBits += 1;
        }
        dictionary[wc] = dictSize;
        dictSize += 1;
        w = String(c);
      }
    }

    if (w !== '') {
      if (hasOwn(dictionaryToCreate, w)) {
        if (w.charCodeAt(0) < 256) {
          writeValue(0, numBits);
          writeValue(w.charCodeAt(0), 8);
        } else {
          writeValue(1, numBits);
          writeValue(w.charCodeAt(0), 16);
        }
        enlargeIn -= 1;
        if (enlargeIn === 0) {
          enlargeIn = Math.pow(2, numBits);
          numBits += 1;
        }
        delete dictionaryToCreate[w];
      } else {
        writeValue(dictionary[w], numBits);
      }
      enlargeIn -= 1;
      if (enlargeIn === 0) {
        numBits += 1;
      }
    }

    writeValue(2, numBits);
    while (true) {
      dataVal = dataVal << 1;
      if (dataPosition === bitsPerChar - 1) {
        data.push(getCharFromInt(dataVal));
        break;
      }
      dataPosition += 1;
    }
    return data.join('');
  }

  function decompressWithBits(length, resetValue, getNextValue) {
    var dictionary = [];
    var enlargeIn = 4;
    var dictSize = 4;
    var numBits = 3;
    var entry = '';
    var result = [];
    var i;
    var w;
    var bits;
    var resb;
    var maxpower;
    var power;
    var c;
    var data = { val: getNextValue(0), position: resetValue, index: 1 };

    function readBits(bitCount) {
      var value = 0;
      maxpower = Math.pow(2, bitCount);
      power = 1;
      while (power !== maxpower) {
        resb = data.val & data.position;
        data.position >>= 1;
        if (data.position === 0) {
          data.position = resetValue;
          data.val = getNextValue(data.index);
          data.index += 1;
        }
        value |= (resb > 0 ? 1 : 0) * power;
        power <<= 1;
      }
      return value;
    }

    for (i = 0; i < 3; i += 1) dictionary[i] = i;
    bits = readBits(2);
    switch (bits) {
      case 0:
        c = String.fromCharCode(readBits(8));
        break;
      case 1:
        c = String.fromCharCode(readBits(16));
        break;
      case 2:
        return '';
      default:
        return null;
    }
    dictionary[3] = c;
    w = c;
    result.push(c);

    while (true) {
      if (data.index > length) return '';
      bits = readBits(numBits);
      switch (bits) {
        case 0:
          dictionary[dictSize] = String.fromCharCode(readBits(8));
          c = dictSize;
          dictSize += 1;
          enlargeIn -= 1;
          break;
        case 1:
          dictionary[dictSize] = String.fromCharCode(readBits(16));
          c = dictSize;
          dictSize += 1;
          enlargeIn -= 1;
          break;
        case 2:
          return result.join('');
        default:
          c = bits;
      }
      if (enlargeIn === 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits += 1;
      }
      if (dictionary[c]) {
        entry = dictionary[c];
      } else if (c === dictSize) {
        entry = w + w.charAt(0);
      } else {
        return null;
      }
      result.push(entry);
      dictionary[dictSize] = w + entry.charAt(0);
      dictSize += 1;
      enlargeIn -= 1;
      w = entry;
      if (enlargeIn === 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits += 1;
      }
    }
  }

  function compress(value) {
    return compressWithBits(value, 6, function (index) {
      return URI_SAFE.charAt(index);
    });
  }

  function decompress(value) {
    var reverse = reverseDictionary();
    if (value == null) return '';
    if (value === '') return null;
    value = String(value).replace(/ /g, '+');
    return decompressWithBits(value.length, 32, function (index) {
      return reverse[value.charAt(index)];
    });
  }

  function updateExtension(name, mimeType) {
    var base = String(name || 'image').replace(/\.[^.]*$/, '');
    return base + '.' + String(mimeType).split('/')[1];
  }

  function fileToDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(String(reader.result || ''));
      };
      reader.onerror = function () {
        reject(reader.error || new Error('Could not read file'));
      };
      reader.readAsDataURL(file);
    });
  }

  function blobToDataUrl(blob) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(String(reader.result || ''));
      };
      reader.onerror = function () {
        reject(reader.error || new Error('Could not read resized image'));
      };
      reader.readAsDataURL(blob);
    });
  }

  function getBitmap(file, dataUrl) {
    if (window.createImageBitmap) {
      return window.createImageBitmap(file);
    }
    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.onload = function () {
        resolve(image);
      };
      image.onerror = reject;
      image.src = dataUrl;
    });
  }

  function isHeicFile(file) {
    // Some file pickers omit HEIC MIME types or use application/octet-stream.
    return /^image\/hei[cf](-sequence)?$/i.test(file.type || '') || /\.hei[cf]$/i.test(file.name || '');
  }

  function loadHeicDecoder() {
    if (typeof window.HeicTo === 'function') return Promise.resolve(window.HeicTo);
    if (!heicDecoderLoading) {
      heicDecoderLoading = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        var timeout;

        function failed() {
          window.clearTimeout(timeout);
          script.remove();
          reject(new Error('Could not load HEIC support. Please check your connection and try again.'));
        }

        script.src = HEIC_DECODER_URL;
        script.async = true;
        script.setAttribute('data-heic-decoder', '');
        script.addEventListener('load', function () {
          window.clearTimeout(timeout);
          if (typeof window.HeicTo === 'function') resolve(window.HeicTo);
          else failed();
        }, { once: true });
        script.addEventListener('error', failed, { once: true });
        timeout = window.setTimeout(failed, 30000);
        document.head.appendChild(script);
      }).catch(function (error) {
        heicDecoderLoading = null;
        throw error;
      });
    }
    return heicDecoderLoading;
  }

  function scaledDimensions(width, height, maxEdge) {
    var ratio;
    if (width <= maxEdge && height <= maxEdge) return { width: width, height: height };
    if (width > height) {
      ratio = maxEdge / width;
    } else {
      ratio = maxEdge / height;
    }
    return {
      width: Math.round(width * ratio),
      height: Math.round(height * ratio)
    };
  }

  function createCanvas(width, height) {
    var canvas;
    try {
      if (typeof window.OffscreenCanvas === 'function') {
        return new window.OffscreenCanvas(width, height);
      }
    } catch (_error) {
      // Fall through to HTML canvas.
    }
    canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }

  function canvasToBlob(canvas) {
    if (typeof canvas.convertToBlob === 'function') {
      return canvas.convertToBlob({ type: OUTPUT_MIME, quality: IMAGE_QUALITY });
    }
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (blob) resolve(blob);
        else reject(new Error('Failed to create resized image'));
      }, OUTPUT_MIME, IMAGE_QUALITY);
    });
  }

  async function resizeFile(file, kind) {
    var dataUrl;
    var bitmap;
    var size;
    var canvas;
    var context;
    var blob;
    var decoder;
    var heic = kind === 'image' && isHeicFile(file);

    if (kind === 'image' && !heic && ACCEPTED_IMAGE_TYPES.indexOf(file.type) === -1) {
      throw new Error(file.name + ' is not a valid file type');
    }
    if (file.size > MAX_IMAGE_BYTES) {
      throw new Error(file.name + ' exceeds the 10MB limit');
    }
    dataUrl = await fileToDataUrl(file);
    if (kind !== 'image') {
      return { file: file, dataUrl: dataUrl, blob: file, mimeType: file.type, name: file.name };
    }

    try {
      bitmap = await getBitmap(file, dataUrl);
    } catch (error) {
      if (!heic) throw error;
      // Keep native HEIC decoding when available; fetch the worker-based
      // converter only on browsers that need it, then use the WebP pipeline.
      decoder = await loadHeicDecoder();
      try {
        blob = await decoder({ blob: file, type: 'image/png' });
        bitmap = await getBitmap(blob, await blobToDataUrl(blob));
      } catch (_error) {
        throw new Error('Could not read this HEIC/HEIF photo. Please export it as JPG and try again.');
      }
    }
    size = scaledDimensions(bitmap.width, bitmap.height, MAX_IMAGE_EDGE);
    canvas = createCanvas(size.width, size.height);
    context = canvas.getContext('2d', { willReadFrequently: true });
    if (!context) throw new Error('Could not create canvas context');
    if ('imageSmoothingQuality' in context) context.imageSmoothingQuality = 'high';
    context.drawImage(bitmap, 0, 0, size.width, size.height);
    if (bitmap.close) bitmap.close();
    blob = await canvasToBlob(canvas);
    return {
      file: file,
      dataUrl: await blobToDataUrl(blob),
      blob: blob,
      mimeType: OUTPUT_MIME,
      name: updateExtension(file.name, OUTPUT_MIME)
    };
  }

  function uploadImage(resized, field, onProgress, abortHooks) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      var aborted = false;
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var abort = function () {
        if (aborted) return;
        aborted = true;
        if (controller) controller.abort();
        if (xhr.abort) xhr.abort();
      };

      if (xhr.upload && typeof xhr.upload.addEventListener === 'function') {
        xhr.upload.addEventListener('progress', function (event) {
          if (event.lengthComputable && onProgress) onProgress(event.loaded / event.total);
        });
      }
      if (abortHooks) abortHooks.setAbort(abort);
      xhr.addEventListener('load', function () {
        var parsed;
        if (abortHooks) abortHooks.setAbort(null);
        if (xhr.status < 200 || xhr.status >= 300) {
          reject(new Error('Upload failed. Please try again.'));
          return;
        }
        try {
          parsed = JSON.parse(xhr.responseText || '{}');
        } catch (_error) {
          parsed = {};
        }
        if (!parsed.url) {
          reject(new Error('Upload response missing URL'));
          return;
        }
        resolve(parsed.url);
      });
      xhr.addEventListener('error', function () {
        if (abortHooks) abortHooks.setAbort(null);
        reject(new Error('Upload failed. Please check your connection and try again.'));
      });
      xhr.addEventListener('abort', function () {
        if (abortHooks) abortHooks.setAbort(null);
        aborted = true;
        reject(new Error('Upload cancelled'));
      });
      xhr.open('POST', config.imageUploadUrl || '');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify({ image: resized.dataUrl, imageKey: field, name: resized.name }));
    });
  }

  function failureMessage(name, error) {
    // lib/imageUtils.ts:243-259 — a NotReadableError means the OS revoked the
    // photo reference; anything with a message is surfaced verbatim.
    var message = error && error.message ? String(error.message) : '';
    if (error && error.name === 'NotReadableError') {
      return 'Couldn’t read ' + name + '. Please select the photo again.';
    }
    if (message.indexOf(name) === 0) return message;
    if (message) return name + ': ' + message;
    return 'Couldn’t upload ' + name + '. Please try again.';
  }

  // One bad photo must never discard the batch: every file is validated,
  // resized and uploaded inside its own try/catch, and the successes are
  // returned alongside the per-file error messages.
  async function uploadFiles(list, kind, field, onProgress, abortHooks) {
    var cachedKeys = [];
    var metaData = [];
    var previewData = [];
    var errors = [];
    var total = Math.max(list.length, 1);
    var index;

    for (index = 0; index < list.length; index += 1) {
      /* eslint-disable no-await-in-loop */
      if (abortHooks && abortHooks.isAborted()) throw new Error('Upload cancelled');
      if (kind === 'image' && storeArray(field).length + cachedKeys.length >= app.MAX_PHOTOS) {
        errors.push(PHOTO_LIMIT_MESSAGE);
        if (onProgress) onProgress(100);
        break;
      }
      await (async function (position) {
        var file = list[position];
        var item;
        var url;
        try {
          item = await resizeFile(file, kind);
          if (abortHooks && abortHooks.isAborted()) throw new Error('Upload cancelled');
          url = await uploadImage(item, field, function (fraction) {
            if (onProgress) onProgress(Math.round(((position + fraction) / total) * 100));
          }, abortHooks);
          cachedKeys.push(url);
          metaData.push({
            name: item.name,
            fileSize: String(item.file.size),
            mimeType: item.mimeType,
            timestamp: Date.now(),
            url: url
          });
          previewData.push(url);
        } catch (error) {
          if (error && error.message === 'Upload cancelled') throw error;
          if (window.console && typeof window.console.error === 'function') {
            window.console.error('Failed to process file', file && file.name, error);
          }
          errors.push(failureMessage(file && file.name ? file.name : 'This file', error));
        }
        if (onProgress) onProgress(Math.round(((position + 1) / total) * 100));
      })(index);
      /* eslint-enable no-await-in-loop */
    }

    return { cachedKeys: cachedKeys, metaData: metaData, previewData: previewData, errors: errors };
  }

  function processFiles(files, kind, field, onProgress) {
    var activeAbort = null;
    var aborted = false;
    var abortHooks = {
      isAborted: function () {
        return aborted;
      },
      setAbort: function (fn) {
        activeAbort = fn;
        if (aborted && activeAbort) activeAbort();
      }
    };
    var promise = (async function () {
      var list = Array.prototype.slice.call(files || []);
      if (aborted) throw new Error('Upload cancelled');
      return uploadFiles(list, kind || 'image', field, onProgress, abortHooks);
    })();
    promise.abort = function () {
      aborted = true;
      if (activeAbort) activeAbort();
    };
    return promise;
  }

  function storeArray(key) {
    return store && Array.isArray(store.get()[key]) ? store.get()[key].slice() : [];
  }

  function setStoreArray(key, array) {
    if (store) store.set(key, array);
  }

  function remove(field, index) {
    [field, 'internal_' + field, 'internal_' + field + '_preview'].forEach(function (key) {
      var array = storeArray(key);
      array.splice(index, 1);
      setStoreArray(key, array);
    });
    render();
  }

  function move(field, from, to, focusIndex) {
    [field, 'internal_' + field, 'internal_' + field + '_preview'].forEach(function (key) {
      var array = storeArray(key);
      var item;
      if (from < 0 || to < 0 || from >= array.length || to >= array.length || from === to) return;
      item = array.splice(from, 1)[0];
      array.splice(to, 0, item);
      setStoreArray(key, array);
    });
    render();
    if (focusIndex !== undefined) focusPhotoHandle(focusIndex);
  }

  function appendUploaded(field, result) {
    var values = {};
    values[field] = storeArray(field).concat(result.cachedKeys);
    values['internal_' + field] = storeArray('internal_' + field).concat(result.metaData);
    values['internal_' + field + '_preview'] = storeArray('internal_' + field + '_preview').concat(result.previewData);
    store.patch(values);
  }

  function nonEmpty(value) {
    if (value === '' || value === false || value === null || value === undefined) return false;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object' && value && 'name' in value) return value.name !== '';
    return true;
  }

  function shorten(state) {
    var output = {};
    Object.keys(state || {}).forEach(function (key) {
      var value = state[key];
      var shortKey;
      if (key === 'internal_processing_files' || SENSITIVE_FIELDS[key] || !nonEmpty(value)) return;
      shortKey = PROPERTY_MAP[key] || key;
      if (Array.isArray(value)) {
        output[shortKey] = key.indexOf('media_') === 0 ? value.length : cloneArray(value);
      } else {
        output[shortKey] = value;
      }
    });
    return output;
  }

  function expand(shortState) {
    var output = {};
    Object.keys(shortState || {}).forEach(function (shortKey) {
      var key = REVERSE_PROPERTY_MAP[shortKey] || shortKey;
      if (key === 'internal_processing_files') return;
      output[key] = shortState[shortKey];
    });
    Object.keys(output).forEach(function (key) {
      if (key.indexOf('media_') === 0 && typeof output[key] === 'number') output[key] = [];
    });
    return output;
  }

  function serializeForHandoff(state, baseUrl) {
    var encoded = compress(JSON.stringify(shorten(state || {})));
    var url = new URL(baseUrl);
    url.searchParams.set('data', encoded);
    if (url.toString().length > 2000) throw new Error('Data too large for QR code');
    return url.toString();
  }

  function hydrateHandoff(encoded) {
    var decoded;
    try {
      if (!encoded) return null;
      decoded = decompress(encoded);
      if (!decoded) return null;
      return expand(JSON.parse(decoded));
    } catch (_error) {
      return null;
    }
  }

  function renderQr(url, element) {
    if (!element || typeof window.QRCode !== 'function') return null;
    element.textContent = '';
    return new window.QRCode(element, {
      text: url,
      width: 600,
      height: 600,
      correctLevel: window.QRCode.CorrectLevel ? window.QRCode.CorrectLevel.L : undefined,
      colorDark: '#000000',
      colorLight: '#ffffff'
    });
  }

  // Photo-card action glyphs use the same simple, currentColor stroke style.
  var ICONS = {
    drag:
      '<svg aria-hidden="true" viewBox="0 0 16 16" fill="currentColor" focusable="false"><circle cx="5" cy="4" r="1.1"/><circle cx="11" cy="4" r="1.1"/><circle cx="5" cy="8" r="1.1"/><circle cx="11" cy="8" r="1.1"/><circle cx="5" cy="12" r="1.1"/><circle cx="11" cy="12" r="1.1"/></svg>',
    remove:
      '<svg aria-hidden="true" viewBox="0 0 16 16" fill="none" focusable="false"><path d="M4.25 4.25l7.5 7.5M11.75 4.25l-7.5 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
  };

  function announcePhotoMove(position, total) {
    var announcement = root && root.querySelector('[data-photo-announcement]');
    if (!announcement) return;
    announcement.textContent = 'Photo moved to position ' + position + ' of ' + total + '.' + (position === 1 ? ' It is now the listing cover.' : '');
  }

  function focusPhotoHandle(index) {
    var list = root && root.querySelector('[data-photo-list]');
    var handles = list ? list.querySelectorAll('[data-photo-drag-handle]') : [];
    if (handles[index] && typeof handles[index].focus === 'function') handles[index].focus();
  }

  function movePhotoWithKeyboard(event, index, total) {
    var destination;
    if (event.key === 'ArrowLeft') destination = index - 1;
    else if (event.key === 'ArrowRight') destination = index + 1;
    else return;
    if (destination < 0 || destination >= total) return;
    event.preventDefault();
    move('media_additional', index, destination, destination);
    announcePhotoMove(destination + 1, total);
  }

  function clearPhotoDropTargets(list) {
    if (!list) return;
    Array.prototype.forEach.call(list.querySelectorAll('.is-drop-before, .is-drop-after'), function (item) {
      item.classList.remove('is-drop-before', 'is-drop-after');
    });
  }

  function clearPhotoDrag(state) {
    var list = state && state.list;
    var source = state && state.source;
    if (source) source.classList.remove('is-dragging');
    if (list) {
      list.classList.remove('is-reordering');
      clearPhotoDropTargets(list);
    }
    if (state && state.preview && state.preview.parentNode) state.preview.parentNode.removeChild(state.preview);
  }

  function startPhotoDrag(event, index, handle, list) {
    if (event.button !== undefined && event.button !== 0) return;
    if (dragState) clearPhotoDrag(dragState);
    dragState = {
      from: index,
      to: index,
      insertAfter: false,
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      active: false,
      handle: handle,
      list: list,
      source: null,
      preview: null
    };
    if (handle.setPointerCapture && event.pointerId !== undefined) {
      try {
        handle.setPointerCapture(event.pointerId);
      } catch (_error) {
        // A pointer can be cancelled before capture on older browsers.
      }
    }
  }

  function updatePhotoDrag(event) {
    var state = dragState;
    var source;
    var frame;
    var image;
    var previewImage;
    var previewLabel;
    var rect;
    var width;
    var target;
    var targetCard;
    var targetIndex;
    if (!state || (state.pointerId !== undefined && event.pointerId !== state.pointerId)) return;
    if (!state.active && Math.abs(event.clientX - state.startX) + Math.abs(event.clientY - state.startY) < 6) return;

    if (!state.active) {
      state.active = true;
      source = state.list.querySelector('[data-media-index="' + state.from + '"]');
      frame = source && source.querySelector('.nl-photo-card__frame');
      image = frame && frame.querySelector('img');
      if (source) source.classList.add('is-dragging');
      state.source = source;
      state.list.classList.add('is-reordering');
      if (image && root) {
        rect = frame.getBoundingClientRect();
        width = Math.min(rect.width, 180);
        state.preview = document.createElement('div');
        state.preview.className = 'nl-photo-drag-preview';
        state.preview.setAttribute('aria-hidden', 'true');
        state.preview.style.width = width + 'px';
        previewImage = document.createElement('img');
        previewImage.src = image.src;
        previewImage.alt = '';
        state.preview.appendChild(previewImage);
        previewLabel = document.createElement('span');
        previewLabel.className = 'nl-photo-drag-preview__label';
        previewLabel.textContent = 'Photo ' + (state.from + 1);
        state.preview.appendChild(previewLabel);
        root.appendChild(state.preview);
      }
    }

    if (event.cancelable) event.preventDefault();
    if (state.preview) {
      width = state.preview.offsetWidth || 150;
      state.preview.style.transform = 'translate3d(' + Math.round(event.clientX - width / 2) + 'px, ' + Math.round(event.clientY - width * 0.42) + 'px, 0)';
    }

    target = document.elementFromPoint ? document.elementFromPoint(event.clientX, event.clientY) : event.target;
    targetCard = target && target.closest ? target.closest('[data-media-index]') : null;
    if (!targetCard || !state.list.contains(targetCard)) {
      clearPhotoDropTargets(state.list);
      state.to = state.from;
      state.insertAfter = false;
      return;
    }

    targetIndex = parseInt(targetCard.getAttribute('data-media-index'), 10);
    clearPhotoDropTargets(state.list);
    state.to = targetIndex;
    if (targetIndex === state.from) {
      state.insertAfter = false;
      return;
    }
    rect = targetCard.getBoundingClientRect();
    state.insertAfter = event.clientX >= rect.left + rect.width / 2;
    targetCard.classList.add(state.insertAfter ? 'is-drop-after' : 'is-drop-before');
  }

  function finishPhotoDrag(event, commit) {
    var state = dragState;
    var destination;
    var total;
    if (!state || (event && state.pointerId !== undefined && event.pointerId !== state.pointerId)) return;
    if (commit && event) updatePhotoDrag(event);
    dragState = null;
    total = state.list.querySelectorAll('[data-media-index]').length;
    if (commit && state.active && state.to !== state.from) {
      destination = state.to + (state.insertAfter ? 1 : 0);
      if (state.from < destination) destination -= 1;
    }
    clearPhotoDrag(state);
    if (commit && state.active && destination !== undefined && destination !== state.from) {
      move('media_additional', state.from, destination, destination);
      announcePhotoMove(destination + 1, total);
    }
  }

  // Mirrors FileInput.tsx's conditional copy: the empty-state dropzone prompt
  // only shows with no photos, then gives way to "Add more files" and the
  // main-image notes. The minimum-photos warning appears only while 1–2 photos
  // are uploaded — at zero it would just repeat the section's requirement.
  function renderPhotoState(previews) {
    var count = Array.isArray(previews) ? previews.length : 0;
    var warning = root && root.querySelector('[data-photo-min-warning]');
    var empty = root && root.querySelector('[data-upload-empty]');
    var addMore = root && root.querySelector('[data-add-more]');
    var primary = root && root.querySelector('[data-upload-primary]');
    var firstImage = root && root.querySelector('[data-first-image-hint]');
    var reorder = root && root.querySelector('[data-reorder-hint]');
    var input = root && root.querySelector('[data-media-input]');
    var region = root && root.querySelector('[data-upload-region]');
    var disabled = count >= app.MAX_PHOTOS || !!(store && store.get().internal_processing_files);

    if (region) region.classList.toggle('has-photos', count > 0);
    if (warning) {
      warning.hidden = !(count > 0 && count < 3);
      warning.textContent = count > 0 && count < 3 ? 'Minimum 3 photos required' : '';
    }
    if (empty) empty.hidden = count > 0;
    if (addMore) addMore.hidden = count === 0;
    if (primary) primary.hidden = count > 0;
    if (input) input.disabled = disabled;
    if (addMore) addMore.disabled = disabled;
    if (primary) primary.disabled = disabled;
    if (firstImage) firstImage.hidden = count === 0;
    if (reorder) reorder.hidden = count < 2;
  }

  function render() {
    var state = store ? store.get() : {};
    var list = root && root.querySelector('[data-photo-list]');
    var count = root && root.querySelector('[data-media-count]');
    var progress = root && root.querySelector('[data-upload-progress]');
    var previews = Array.isArray(state.internal_media_additional_preview) ? state.internal_media_additional_preview : [];
    var meta = Array.isArray(state.internal_media_additional) ? state.internal_media_additional : [];

    renderHandoffTrigger(state);
    renderPhotoState(previews);
    if (count) count.textContent = previews.length + ' / 3 minimum';
    if (progress && !state.internal_processing_files) {
      progress.textContent = '';
      progress.hidden = true;
    }
    if (!list) return;
    list.textContent = '';
    previews.forEach(function (preview, index) {
      var item = document.createElement('li');
      var frame = document.createElement('div');
      var image = document.createElement('img');
      var details = document.createElement('div');
      var position = document.createElement('span');
      var dragHandle = document.createElement('button');
      var removeButton = document.createElement('button');

      item.className = 'nl-photo-card';
      frame.className = 'nl-photo-card__frame';
      details.className = 'nl-photo-card__details';
      position.className = 'nl-photo-card__position';

      item.setAttribute('data-media-index', String(index));
      item.setAttribute('aria-label', (meta[index] && meta[index].name ? meta[index].name : 'Photo') + ' photo tile');
      image.src = preview;
      image.alt = meta[index] && meta[index].name ? meta[index].name : 'Uploaded bike photo';
      frame.appendChild(image);

      dragHandle.type = 'button';
      dragHandle.className = 'nl-photo-card__drag';
      dragHandle.setAttribute('data-photo-drag-handle', '');
      dragHandle.setAttribute('aria-label', previews.length < 2
        ? 'Add another photo to enable reordering.'
        : 'Reorder photo ' + (index + 1) + '. Drag to move, or use the Left and Right Arrow keys.');
      dragHandle.setAttribute('aria-keyshortcuts', 'ArrowLeft ArrowRight');
      dragHandle.disabled = previews.length < 2;
      dragHandle.innerHTML = ICONS.drag;
      dragHandle.title = previews.length < 2 ? 'Add another photo to reorder' : 'Drag to reorder';
      dragHandle.addEventListener('keydown', function (event) {
        movePhotoWithKeyboard(event, index, previews.length);
      });
      dragHandle.addEventListener('pointerdown', function (event) {
        startPhotoDrag(event, index, dragHandle, list);
      });
      dragHandle.addEventListener('pointermove', updatePhotoDrag);
      dragHandle.addEventListener('pointerup', function (event) {
        finishPhotoDrag(event, true);
      });
      dragHandle.addEventListener('pointercancel', function (event) {
        finishPhotoDrag(event, false);
      });
      dragHandle.addEventListener('lostpointercapture', function (event) {
        finishPhotoDrag(event, false);
      });
      frame.appendChild(dragHandle);

      removeButton.type = 'button';
      removeButton.className = 'nl-photo-card__action nl-photo-card__action--remove';
      removeButton.setAttribute('data-photo-remove', '');
      removeButton.innerHTML = ICONS.remove;
      removeButton.title = 'Remove photo';
      removeButton.setAttribute('aria-label', 'Remove photo ' + (index + 1));
      removeButton.addEventListener('click', function () {
        remove('media_additional', index);
      });
      frame.appendChild(removeButton);

      if (index === 0) {
        var coverLabel = document.createElement('span');
        coverLabel.className = 'nl-photo-card__cover';
        coverLabel.setAttribute('data-photo-cover-label', '');
        coverLabel.textContent = 'Listing cover';
        frame.appendChild(coverLabel);
      }
      position.textContent = 'Photo ' + (index + 1);
      details.appendChild(position);
      item.appendChild(frame);
      item.appendChild(details);
      list.appendChild(item);
    });
  }

  // QrCodeShare.tsx:69-83 renders nothing unless the viewport is desktop and the
  // form already holds data, so the trigger must not exist in either case.
  function renderHandoffTrigger(state) {
    var trigger = root && root.querySelector('[data-handoff-open]');
    if (!trigger) return;
    trigger.hidden = !(isDesktop() && Object.keys(state || {}).some(function (key) {
      return nonEmpty((state || {})[key]);
    }));
  }

  function isDesktop() {
    if (window.matchMedia) return window.matchMedia('(min-width: 1024px)').matches;
    return window.innerWidth >= 1024;
  }

  function baseHandoffUrl() {
    return window.location.origin + '/pages/new-listing';
  }

  // Spec: blocking failures use an assertive announcement, separate from the
  // polite upload-progress line.
  function setUploadError(message) {
    var node = root && root.querySelector('[data-upload-error]');
    if (!node) return;
    node.textContent = message || '';
    node.hidden = !message;
  }

  // Shared by the <input type="file"> change event and drops onto the upload
  // region: toggle the processing flag, run the batch through processFiles,
  // append the successes, then surface per-file errors on the error region.
  async function handleFiles(files) {
    var input = root.querySelector('[data-media-input]');
    var progress = root.querySelector('[data-upload-progress]');
    var field;
    var result;
    if (!input || !files || !files.length) return;
    // A second selection or drop must not race the current batch's photo count.
    if (store.get().internal_processing_files) return;
    field = input.getAttribute('data-media-field') || 'media_additional';
    store.set('internal_processing_files', true);
    setUploadError('');
    if (progress) {
      progress.textContent = 'Uploading photos… 0%';
      progress.hidden = false;
    }
    try {
      result = await processFiles(files, input.getAttribute('data-media-kind') || 'image', field, function (value) {
        if (progress) {
          progress.textContent = 'Uploading photos… ' + Math.round(value) + '%';
          progress.hidden = false;
        }
      });
      appendUploaded(field, result);
      setUploadError((result.errors || []).join(' '));
      if (progress) {
        progress.textContent = '';
        progress.hidden = true;
      }
    } catch (error) {
      if (window.console && typeof window.console.error === 'function') {
        window.console.error('Photo upload failed:', error);
      }
      setUploadError(error && error.message ? error.message : 'Couldn’t upload your photos. Please try again.');
      if (progress) {
        progress.textContent = '';
        progress.hidden = true;
      }
    } finally {
      store.set('internal_processing_files', false);
      input.value = '';
      render();
    }
  }

  function bindUpload() {
    var region;
    if (!root) return;
    // The whole region is a click target (FileInput.tsx dropzone root), so
    // both the trigger buttons and a click on the region's empty area open the
    // same hidden input. Clicks that bubble back up from input.click() itself
    // are ignored so the picker can't re-open itself.
    root.addEventListener('click', function (event) {
      var target = event.target;
      var input = root.querySelector('[data-media-input]');
      var trigger = target && target.closest ? target.closest('[data-upload-trigger]') : null;
      var regionMatch = target && target.closest ? target.closest('[data-upload-region]') : null;
      if ((!trigger && !regionMatch) || target === input) return;
      if (!root.contains(trigger || regionMatch)) return;
      if (input && !input.disabled && input.click) input.click();
    });
    root.addEventListener('change', function (event) {
      var input = event.target.closest('[data-media-input]');
      if (!input || !root.contains(input)) return;
      handleFiles(input.files);
    });
    // Drag-and-drop: a dashed-border dropzone that highlights while a file
    // drag hovers it and routes any dropped files through the same pipeline.
    region = root.querySelector('[data-upload-region]');
    if (!region) return;
    region.addEventListener('dragenter', function (event) {
      event.preventDefault();
      region.classList.add('is-dragging');
    });
    region.addEventListener('dragover', function (event) {
      event.preventDefault();
      region.classList.add('is-dragging');
    });
    region.addEventListener('dragleave', function (event) {
      if (!region.contains(event.relatedTarget)) region.classList.remove('is-dragging');
    });
    region.addEventListener('drop', function (event) {
      event.preventDefault();
      region.classList.remove('is-dragging');
      handleFiles(event.dataTransfer && event.dataTransfer.files);
    });
  }

  function removeHandoffParam() {
    var url;
    if (!window.location || !window.history || typeof window.history.replaceState !== 'function' || !window.URL) return;
    url = new URL(window.location.href);
    url.searchParams.delete('data');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function bindHandoff() {
    var params;
    var hydrated;
    if (!root) return;
    params = new URLSearchParams(window.location.search || '');
    if (params.has('data')) {
      hydrated = hydrateHandoff(params.get('data'));
      if (hydrated && store) store.patch(hydrated);
      integrations.capture('page_load_with_url_data');
      // context/formData.ts:487-498 deletes the consumed snapshot immediately so a
      // reload cannot re-apply it over newer state, and so the draft leaves the
      // address bar, analytics URLs and any onward referrer.
      removeHandoffParam();
    }
    root.addEventListener('click', function (event) {
      var handoffDialog = event.target.closest('[data-handoff-dialog]');
      var trigger = event.target.closest('[data-handoff-open]');
      var dialog;
      var qr;
      var error;
      var url;
      // A modal dialog receives backdrop clicks at the dialog element. Keeping
      // this alongside the handoff binding limits outside-click dismissal to
      // the QR flow; the submission dialog remains deliberate.
      if (handoffDialog && root.contains(handoffDialog) && event.target === handoffDialog) {
        if (typeof handoffDialog.close === 'function' && handoffDialog.open) handoffDialog.close();
        else handoffDialog.removeAttribute('open');
        return;
      }
      if (!trigger || !root.contains(trigger)) return;
      integrations.capture('continue_on_phone');
      dialog = root.querySelector('[data-handoff-dialog]');
      if (dialog && dialog.showModal) dialog.showModal();
      else if (dialog) dialog.setAttribute('open', '');
      if (!isDesktop()) return;
      qr = root.querySelector('[data-handoff-qr]');
      error = root.querySelector('[data-handoff-error]');
      try {
        url = serializeForHandoff(store.get(), baseHandoffUrl());
        if (error) error.textContent = '';
        renderQr(url, qr);
      } catch (exception) {
        if (error) error.textContent = exception.message || 'Could not generate handoff QR code';
      }
    });
  }

  function init(context) {
    root = context.root;
    store = context.store;
    config = context.config || {};
    integrations = context.integrations || integrations;
    if (boundRoot === root) {
      render();
      return;
    }
    boundRoot = root;
    bindUpload();
    bindHandoff();
    if (store) store.subscribe(render);
    render();
  }

  app.register('media', {
    init: init,
    processFiles: processFiles,
    remove: remove,
    move: move,
    serializeForHandoff: serializeForHandoff,
    renderHandoffTrigger: renderHandoffTrigger,
    hydrateHandoff: hydrateHandoff,
    compress: compress,
    decompress: decompress,
    renderQr: renderQr
  });
})(window, document);
